import React, { useState } from 'react';
import jwtDecode from 'jwt-decode';
import { useSelector } from 'react-redux';
import {
  DISTRIBUTORUSERTYPE,
  USERSTATUS,
} from '../../../../../constants/selects';
import useCreateDistributorUser from '../../../../../hooks/distributorUser/useCreateDistributorUser';
import useCreateDistributorUserMaster from '../../../../../hooks/distributorUser/useCreateDistributorUserMaster';
import useUpdateDistributorUser from '../../../../../hooks/distributorUser/useUpdateDistributorUser';
import { checkAdmin } from '../../../../../services/validation';
import { ApplicationState } from '../../../../../store';
import ActivityIndicator from '../../../../ActivityIndicator';
import Input from '../../../../atoms/input';
import { Grid } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import ButtonComponent from '../../../../atoms/button';
import Typography from '../../../../atoms/typography';
import SelectCustom from '../../../../atoms/selectCustom';
import { SelectChangeEvent } from '@mui/material/Select';
import InputDisabled from '../../../../atoms/inputDisabled';

const FormUpdateDistributorUser: React.FC<any> = ({
  onClick,
  selectedUserId,
}: any) => {
  const { control } = useForm();
  const { execute, loading } = useCreateDistributorUser();
  const { execute: executeRegisterMaster, loading: loadingRegisterMaster } =
    useCreateDistributorUserMaster();

  const { execute: executeUpdateDistributorUser, loading: loadingUpdate } =
    useUpdateDistributorUser();
  const token = useSelector(
    (state: ApplicationState) => state.auth.token || state.distributor.token,
  );
  const { email, username, distributorUserType, status } = useSelector(
    (state: ApplicationState) => state.distributorUser,
  );

  const [distributorUser, setDistributorUser] = useState({
    username: username,
    email: email,
    password: '',
    distributorUserType: distributorUserType || DISTRIBUTORUSERTYPE[1].value,
    status: status,
    IsDataChanged: false,
  });

  const userLoggedData: any = jwtDecode(token);
  const userId = userLoggedData.distributorUserId;

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (checkAdmin(token) && !userId) {
      return await executeRegisterMaster('', distributorUser);
    }
    if (selectedUserId) {
      return await executeUpdateDistributorUser(
        selectedUserId,
        distributorUser,
      );
    } else {
      return await execute(distributorUser);
    }
  };

  if (loading || loadingRegisterMaster || loadingUpdate) {
    return <ActivityIndicator />;
  }

  return (
    <>
      <Typography fontWeight="700" color="secondary" mb={2}>
        Editar usuário
      </Typography>
      <Grid container spacing={2} style={{ marginTop: 4 }}>
        <Grid item xs={6}>
          <Input
            size="small"
            label={'Nome'}
            placeholder="Bento Luiz Ricardo Farias"
            name="name"
            control={control}
            maxLength={50}
            value={distributorUser.username}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setDistributorUser({
                ...distributorUser,
                username: event.target.value,
                IsDataChanged: true,
              })
            }
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            size="small"
            label={'E-mail'}
            placeholder="bento-farias81@gmail.com"
            name="email"
            control={control}
            maxLength={50}
            value={distributorUser.email}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setDistributorUser({
                ...distributorUser,
                email: event.target.value,
                IsDataChanged: true,
              })
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 4 }}>
        <Grid item xs={6}>
          <InputDisabled
            label={'Tipo'}
            size="small"
            defaultValue="Básico"
            value={distributorUser.distributorUserType}
            onChange={(selectedOption: any) =>
              setDistributorUser({
                ...distributorUser,
                distributorUserType: selectedOption.value,
                IsDataChanged: true,
              })
            }
          />
        </Grid>
        <Grid item xs={6}>
          <SelectCustom
            label={'Status'}
            size="small"
            placeholder="Ativo"
            defaultValue="Ativo"
            value={distributorUser.status}
            options={USERSTATUS.map(
              (item: { name: string; value: string }) => ({
                label: item.name,
                value: item.value,
              }),
            )}
            onChange={(event: SelectChangeEvent<unknown>) => {
              const selectedValue = event.target.value as string;
              setDistributorUser({
                ...distributorUser,
                status: selectedValue,
                IsDataChanged: true,
              });
            }}
          />
        </Grid>
      </Grid>

      <Grid container justifyContent="space-between" style={{ marginTop: 20 }}>
        <ButtonComponent
          theme="outline-primary"
          justifyContent="flex-start"
          flex={1}
          onClick={() => onClick('')}
        >
          Cancelar
        </ButtonComponent>
        <ButtonComponent
          theme="primary"
          justifyContent="flex-end"
          flex={1}
          onClick={handleSubmit}
          disabled={!distributorUser.IsDataChanged}
        >
          Salvar alterações
        </ButtonComponent>
      </Grid>
    </>
  );
};

export default FormUpdateDistributorUser;
